import React from 'react';
import { useDialog } from '~/components/dialog/dialog';
import linkHelper from '~/helpers/link';
import useUserContext from '~/contexts/user';
import { useDataFromSlug, camelCaseKeys } from '~/helpers/page-data-utils';
import ContactInfo from '~/components/contact-info/contact-info';
import { RoleDropdown } from '~/components/role-selector/role-selector';
import FormInput from '~/components/form-input/form-input';
import DropdownSelect from '~/components/select/drop-down/drop-down';
import useFormTarget from '~/components/form-target/form-target';
import useBlogContext from '../blog-context';
import cn from 'classnames';
import settings from '~/helpers/window-settings';
import './gated-content-dialog.scss';
const formSubmitUrl = settings().gatedContentEndpoint;
export default function WaitForData({ articleData }) {
    return (articleData === null || articleData === void 0 ? void 0 : articleData.gatedContent) ? React.createElement(GatedContentDialog, null) : null;
}
function GatedContentDialog() {
    const [Dialog, open, close] = useDialog();
    const { userModel } = useUserContext();
    const [submitted, setSubmitted] = React.useState(false);
    React.useEffect(() => {
        if ((userModel === null || userModel === void 0 ? void 0 : userModel.id) || submitted) {
            close();
        }
        else {
            open();
        }
    }, [userModel, open, close, submitted]);
    return (React.createElement(Dialog, { title: "Thanks for reading the OpenStax blog.", className: "gated-content" },
        React.createElement(GatedContentBody, { submitted, setSubmitted })));
}
function GatedContentBody({ submitted, setSubmitted }) {
    const loginLocation = new window.URL(linkHelper.loginLink());
    return (React.createElement("div", { className: "dialog-body" },
        React.createElement("div", { className: "instructions" }, "This post is exclusive. Please login or fill out the form to access the article."),
        React.createElement("a", { className: "btn secondary", href: loginLocation.href, "data-local": "true" }, "Login to my account"),
        React.createElement(GatedContentForm, { submitted, setSubmitted })));
}
function SubjectSelector() {
    const { subjectSnippet: data } = useBlogContext();
    const options = React.useMemo(() => data.map((obj) => ({
        label: obj.name,
        value: obj.name
    })), [data]);
    const [value, setValue] = React.useState();
    const message = value ? '' : 'Please select one';
    return (React.createElement("div", { className: "form-input" },
        React.createElement("div", { className: "control-group" },
            React.createElement("label", { className: "field-label" }, "Subject of interest"),
            React.createElement(DropdownSelect, { name: "subject", required: true, options: options, placeholder: "Please select one", onValueUpdate: setValue }),
            React.createElement("div", { className: "invalid-message" }, message))));
}
function GatedContentForm({ submitted, setSubmitted }) {
    const afterSubmit = React.useCallback(() => setSubmitted(true), [setSubmitted]);
    const { onSubmit, FormTarget } = useFormTarget(afterSubmit);
    const [selectedRole, setSelectedRole] = React.useState();
    return (React.createElement(React.Fragment, null,
        React.createElement(FormTarget, null),
        React.createElement("form", { className: cn({ submitted }), action: formSubmitUrl, onSubmit: onSubmit, target: "form-target" },
            React.createElement(ContactInfo, null,
                React.createElement(SubjectSelector, null),
                React.createElement(RoleSelector, { value: selectedRole, setValue: setSelectedRole }),
                selectedRole === 'Faculty' && (React.createElement(FormInput, { label: "Number of students you teach", inputProps: {
                        type: 'number',
                        name: 'num_students',
                        required: true,
                        min: 1,
                        max: 999
                    } }))),
            React.createElement("button", { className: "primary" }, "Submit"))));
}
function RoleSelector({ value, setValue }) {
    const roleData = useDataFromSlug('snippets/roles');
    const roleOptions = React.useMemo(() => camelCaseKeys(roleData) || [], [roleData]);
    const message = value ? '' : 'Please select one';
    return (React.createElement("div", { className: "form-input" },
        React.createElement("div", { className: "control-group" },
            React.createElement("label", { className: "field-label" }, "Your role"),
            React.createElement(RoleDropdown, { options: roleOptions, setValue: setValue, name: "role" }),
            React.createElement("div", { className: "invalid-message" }, message))));
}
